import { supabase } from './supabaseClient';

// Raw fetch (not supabase.functions.invoke) on purpose — invoke() swallows
// the JSON body of a non-2xx response behind a generic "non-2xx status
// code" error, and core-send-notification returns 400 with a real
// {error: "..."} message for validation failures (empty phone/message)
// that we want to show the user, not swallow. Same reasoning as
// adminApi.ts's callAdminUsers.
export interface SendAdhocSmsResult {
  ok: boolean;
  error?: string;
}

export async function sendAdhocSms(to_phone: string, message: string, source: string): Promise<SendAdhocSmsResult> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in');

  const res = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/core-send-notification`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      'Content-Type': 'application/json',
      apikey: import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({ action: 'send_adhoc', to_phone, message, source }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json.error ?? `Request failed (${res.status})`);
  }
  return json as SendAdhocSmsResult;
}

export interface SmsLogRow {
  id: string;
  to_phone: string;
  message: string;
  sent_by: string | null;
  sent_by_name: string | null;
  status: 'sent' | 'failed';
  error: string | null;
  source: string;
  created_at: string;
}

// rxk's own SMS history is scoped to the signed-in staff member's own sent
// messages only — the ERP page is the one place that shows everyone's
// (see erp-thekseoul's smsApi.ts, deliberately unfiltered there). Same
// RLS/table either way; this is an app-level view choice, not a
// permission difference.
export async function listSmsLog(sentBy: string): Promise<SmsLogRow[]> {
  const { data, error } = await supabase
    .from('sms_log')
    .select('*')
    .eq('sent_by', sentBy)
    .order('created_at', { ascending: false })
    .limit(300);
  if (error) throw error;
  return (data as SmsLogRow[]) ?? [];
}
